import { IconName } from '@talos/kyoko';
import type { TabGroupSpec } from '../../../../types/LayoutConfig';

export const PANEL_COMPONENT_GROUPS = [
  { type: 'main', label: 'Main content', icon: IconName.ArrowsExpand },
  { type: 'symbol', label: 'Single symbol', icon: IconName.OrderBook },
  { type: 'blotters', label: 'Blotters', icon: IconName.Table },
  { type: 'dealer', label: 'Dealer', icon: IconName.Collection },
  { type: 'forms', label: 'Forms', icon: IconName.PencilField },
  { type: 'monitoring', label: 'Monitoring', icon: IconName.DeviceDesktop },
  { type: 'signals', label: 'Signals', icon: IconName.ChartLine },
].reduce((res: Record<string, TabGroupSpec>, group: TabGroupSpec) => {
  res[group.type] = group;
  return res;
}, {});
